import React, { useRef } from 'react';

function MyFormComponent() {
  const submittedRef = useRef(null);

  const handleSubmit = (e) => {
    if (submittedRef.current) {
      submittedRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        {/* Your form fields */}
        <button type="submit">Submit</button>
      </form>

      <div onClick={handleSubmit}>handleSubmit</div>

      {/* Some space for scrolling */}
      <div style={{ height: '500px' }}></div>

      {/* The section to scroll to */}
      <div ref={submittedRef}>
        <h2>Form Submitted!</h2>
        <p>Thank you for submitting the form.</p>
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div>
  );
}

export default MyFormComponent;
